import { createReducer } from "redux-starter-kit";
import { setPdfImageBoxesAction } from "../actions/singlePdfPageContainer";

const INIT_STATE = {
  leftImageBoxes: [],
  rightImageBoxes: []
};

const singlePdfPageContainer = createReducer(INIT_STATE, {
  [setPdfImageBoxesAction]: (state, action) => {
    if (action.payload.isLeft) {
      state.leftImageBoxes = action.payload.imageBoxes;
    } else {
      state.rightImageBoxes = action.payload.imageBoxes;
    }
  }
});

export default singlePdfPageContainer;
